import { Reducer } from 'redux'
import { CombinedFundingSummaryResponse } from './fundingApi'

export interface FundingSummaryState {
  /** Combined funding summary (all programs): stat-card totals + ToDo lists. */
  fundingSummary: CombinedFundingSummaryResponse | null
  /** Partner whose response populated fundingSummary. */
  partnerId: string | null
}

export enum FundingSummaryActionTypes {
  SET_FUNDING_SUMMARY = 'FUNDING_SUMMARY_SET',
  SET_FUNDING_SUMMARY_FOR_ACCOUNT = 'FUNDING_SUMMARY_SET_FOR_ACCOUNT',
}

type FundingSummaryAction =
  | {
      type: FundingSummaryActionTypes.SET_FUNDING_SUMMARY
      payload: CombinedFundingSummaryResponse | null
    }
  | {
      type: FundingSummaryActionTypes.SET_FUNDING_SUMMARY_FOR_ACCOUNT
      payload: {
        partnerId: string
        fundingSummary: CombinedFundingSummaryResponse | null
      }
    }

export const initialState: FundingSummaryState = {
  fundingSummary: null,
  partnerId: null,
}

export const reducer: Reducer<FundingSummaryState, FundingSummaryAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FundingSummaryActionTypes.SET_FUNDING_SUMMARY:
      return { ...state, fundingSummary: action.payload, partnerId: null }
    case FundingSummaryActionTypes.SET_FUNDING_SUMMARY_FOR_ACCOUNT:
      return {
        ...state,
        fundingSummary: action.payload.fundingSummary,
        partnerId: action.payload.partnerId,
      }
    default:
      return state
  }
}
